"use client";

import type { ReactNode } from "react";

/** Strip leading numbering (e.g. "298.1 ", "1.2.3 ") so we can apply our own section label. */
export function stripSectionNumbering(heading: string): string {
  if (!heading?.trim()) return heading ?? "";
  return heading.replace(/^\d+(?:\.\d+)*\.?\s*/, "").trim() || heading.trim();
}

/**
 * Shared “Section N” divider + optional heading; body is children (proactive: one markdown block; remedial: multiple blocks).
 */
export function LessonSectionFrame({
  sectionNumber,
  heading,
  children,
}: {
  sectionNumber: number;
  heading: string;
  children: ReactNode;
}) {
  return (
    <section className="space-y-3">
      <div className="flex items-center gap-4 mb-10 opacity-60 h-5">
        <div className="flex-1 flex items-center self-stretch min-w-0">
          <div className="h-px w-full bg-slate-300" />
        </div>
        <div className="text-[10px] font-black text-slate-500 uppercase tracking-[0.4em] px-4 leading-none flex-shrink-0 m-0 flex items-center">
          Section {sectionNumber}
        </div>
        <div className="flex-1 flex items-center self-stretch min-w-0">
          <div className="h-px w-full bg-slate-300" />
        </div>
      </div>
      {heading ? (
        <h2 className="text-lg font-semibold text-gray-900">{heading}</h2>
      ) : null}
      {children}
    </section>
  );
}

/** Default prose stack for section body (markdown + KaTeX + mermaid segments). */
export const lessonSectionBodyProseClass =
  "prose prose-slate max-w-none prose-p:text-gray-700 prose-li:text-gray-700 learning-content";

export const lessonSectionBodyGapClass = "space-y-6";
